import { render } from "./WorkstreamDetailView.vue?vue&type=template&id=2639c8e2&scoped=true"
import script from "./WorkstreamDetailView.vue?vue&type=script&lang=js"
export * from "./WorkstreamDetailView.vue?vue&type=script&lang=js"

import "./WorkstreamDetailView.vue?vue&type=style&index=0&id=2639c8e2&scoped=true&lang=css"
import "./WorkstreamDetailView.vue?vue&type=style&index=1&id=2639c8e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2639c8e2"]])

export default __exports__